export * from './abstract-advtech.service';
export * from './image/index';
export * from './urs/index';
export * from './mobile/index';



// WEBPACK FOOTER //
// ./src/app/shared/services/advtech/index.ts